module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "HeaderTY-cmp"
  }, [_c('div', {
    staticClass: "header-pc clearfix hidden-xs hidden-sm"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-right-pc clearfix"
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('ul', [_vm._m(1), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.searchHotel
    }
  }, [_vm._v("查找酒店")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": this.$LoginUrl + '/?url=' + this.$ReturnUrl + '/jump-page'
    }
  }, [_vm._v("粤海荟")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-right": "30px"
    }
  }, [_c('span', {
    staticClass: "leftLine"
  }), _vm._v(" "), _c('span', {
    staticClass: "tabLanguage",
    on: {
      "click": function($event) {
        _vm.showLanguage = !_vm.showLanguage
      }
    }
  }, [_vm._v("语言")]), _vm._v(" "), _c('el-collapse-transition', [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLanguage),
      expression: "showLanguage"
    }],
    staticClass: "yuyanTab"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.ZNurl
    }
  }, [_vm._v("简体中文")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.ENurl
    }
  }, [_vm._v("English")])])])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/yh/icon/logo.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com"
    }
  }, [_vm._v("首页")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/conference_banquet/conference_banquet.html"
    }
  }, [_vm._v("会议与宴会")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/about/group-introduction.html"
    }
  }, [_vm._v("集团介绍")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://booking.gdhhotels.com/auth/?url=http://booking.gdhhotels.com/pc/jump-page?from=order"
    }
  }, [_vm._v("我的订单")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51feea30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/HeaderYH.vue
// module id = 596
// module chunks = 28